export default {
    // raiz: 'https://pruebasmcm.gphsis.com/universidad/index.php/'
    raiz: 'https://universidadmaderas.com/buniversity/index.php/'
};
